import { useEffect, useState } from "react";
import { Plus, Search } from "lucide-react";
import api from "../lib/api";
import { notify } from "../lib/toast";
import { checkBudgetAfterTx } from "../lib/budget";
import TransactionRow from "../components/TransactionRow";
import TransactionModal from "../components/TransactionModal";

export default function TransactionsPage() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("all");
  const [q, setQ] = useState("");
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (type !== "all") params.type = type;
      if (q) params.q = q;
      const [tx, a, c] = await Promise.all([
        api.get("/transactions", { params }),
        accounts.length ? Promise.resolve({ data: accounts }) : api.get("/accounts"),
        contacts.length ? Promise.resolve({ data: contacts }) : api.get("/contacts"),
      ]);
      setItems(tx.data);
      setAccounts(a.data);
      setContacts(c.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, [type]);

  const onDelete = async (item) => {
    if (!window.confirm(`"${item.description}" silinsin mi?`)) return;
    try {
      await api.delete(`/transactions/${item.id}`);
      notify.success("İşlem silindi");
      load();
    } catch {
      notify.error("İşlem silinemedi");
    }
  };

  const onEdit = (item) => {
    setEditing(item);
    setModal(true);
  };

  const onSave = async (payload) => {
    if (editing) {
      await api.patch(`/transactions/${editing.id}`, payload);
      notify.success("İşlem güncellendi");
    } else {
      await api.post("/transactions", payload);
      notify.success("İşlem eklendi");
      checkBudgetAfterTx(payload);
    }
    await load();
  };

  const closeModal = () => {
    setModal(false);
    setEditing(null);
  };

  return (
    <>
      <div className="page-head">
        <div>
          <div className="eyebrow">İŞLEMLER</div>
          <h1>Gelir · Gider</h1>
          <p>Tüm finansal hareketlerinizi tek listede yönetin.</p>
        </div>
        <div className="head-actions">
          <button className="primary-btn" onClick={() => setModal(true)} data-testid="add-transaction-button">
            <Plus size={17} /> İşlem ekle
          </button>
        </div>
      </div>

      <div className="panel transactions-panel inner-page" data-testid="transactions-panel">
        <div className="panel-head filter-head">
          <div className="segmented sm">
            <button className={type === "all" ? "active" : ""} onClick={() => setType("all")} data-testid="filter-all">Tümü</button>
            <button className={type === "income" ? "active" : ""} onClick={() => setType("income")} data-testid="filter-income">Gelir</button>
            <button className={type === "expense" ? "active" : ""} onClick={() => setType("expense")} data-testid="filter-expense">Gider</button>
          </div>
          <form className="search-input" onSubmit={(e) => { e.preventDefault(); load(); }}>
            <Search size={14} />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Açıklama, kategori, cari ara…"
              data-testid="transactions-search"
            />
          </form>
        </div>

        {loading ? (
          <div className="page-loading">Yükleniyor…</div>
        ) : items.length === 0 ? (
          <div className="empty-state" data-testid="transactions-empty">
            <h3>Henüz işlem yok</h3>
            <p>İlk gelir veya giderinizi ekleyerek başlayın.</p>
            <button className="primary-btn" onClick={() => setModal(true)} data-testid="empty-add-tx-btn">
              <Plus size={14} /> İşlem ekle
            </button>
          </div>
        ) : (
          <div className="transaction-list">
            {items.map((t) => (
              <TransactionRow item={t} key={t.id} onDelete={onDelete} onEdit={onEdit} />
            ))}
          </div>
        )}
      </div>

      <TransactionModal
        open={modal}
        onClose={closeModal}
        onSave={onSave}
        accounts={accounts}
        contacts={contacts}
        initial={editing}
      />
    </>
  );
}
